export const RequestStatus = {
  inQueue: 1,
  inProgress: 2,
  completed: 3,
  closed: 4
} as const;

export type RequestStatusType = keyof typeof RequestStatus;
export type RequestStatusCodes = (typeof RequestStatus)[keyof typeof RequestStatus];
